import React, { Component } from 'react';
import { connect } from 'react-redux';
import { resetPassword } from '../../actions/password/reset'
import { Button, Form, Grid, Header, Segment, Label } from 'semantic-ui-react'
import '../../App.css';
import { SYSTEM_TITLE } from '../../constants'

class ResetPassword extends Component {
  constructor(props){
    super(props);
    this.state = {
      email: ''
    }
  }

  //Set the messageShown state to TRUE before the props are updated
  componentWillReceiveProps(){
    this.setState({
      messageShown: true
    })
  }

  showForm() {
    if(this.state.messageShown && !this.props.resetFailure && !this.props.pending) {
      return
    }

    return (
      <div>
        <Header as='h2' color='teal' textAlign='center'>
          Reset your password
        </Header>
        <Form size='large'>
          <Segment>
            <Form.Input
              fluid
              icon='user'
              iconPosition='left'
              placeholder='E-mail address'
              type='email'
              onChange={event => this.setState({email: event.target.value})}
            />
            <Button loading={this.props.pending} color='teal' fluid size='large' onClick={() => this.props.reset(this.state.email)}>Submit</Button>
          </Segment>
        </Form>
      </div>
    )
  }
  showMessage() {
    if(!this.props.resetFailure && !this.props.pending) {
      return (<Header as='h4' color='teal' textAlign='center'><p>Reset password link was sent to your email.</p><Button color='teal' href="/">Log in</Button></Header>)
    }
    else if(this.props.resetFailure && !this.props.pending) {
      return (<div><br/><Label color='red'>Please enter valid email.</Label></div>)
    }
  }

  render(props) {
    return (
      <div>
        <header className="App-header">
          <h1 className="App-title">{SYSTEM_TITLE}</h1>
        </header>
        <div className='reset-password-form'>
          <Grid
            textAlign='center'
            style={{ height: '100%' }}
            verticalAlign='middle'
          >
            <Grid.Column style={{ maxWidth: 450 }}>
              {this.showForm()}
              {this.state.messageShown && this.showMessage()}
            </Grid.Column>
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    resetFailure: state.reset_password.resetFailure,
    pending: state.reset_password.pending,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    reset: (email) => {
      dispatch(resetPassword(email))
    }
  }
}

let ResetPasswordPage = connect(mapStateToProps, mapDispatchToProps)(ResetPassword)
export default ResetPasswordPage;



// WEBPACK FOOTER //
// ./src/views/password/reset.js